<script>
import SearchObject from './vue/components/SearchObject.js';
import Search from './vue/components/Search.vue';
import StreamPlayer from "./vue/components/StreamPlayer.vue";
import OfferCounter from "./vue/components/OfferCounter.vue";
import OfferDetailCounter from "./vue/components/OfferDetailCounter.vue";
import SearchHeader from "./vue/components/SearchHeader.vue";
import SearchOverlay from "./vue/components/SearchOverlay.vue";
import SocialStats from "./vue/components/SocialStats.vue";
import MoreResults from "./vue/components/MoreResults.vue";
import PollMarkup from "./vue/components/PollMarkup.vue";
import TypeFilter from "./vue/components/Search/TypeFilter.vue";
import TeaserLiveTv from "./vue/components/TeaserLiveTv.vue";
import TvProgramSelect from "./vue/components/TvProgram/TvProgramSelect.vue";
import TvProgramList from "./vue/components/TvProgram/TvProgramList.vue";
import TvProgramFilter from "./vue/components/TvProgram/TvProgramFilter.vue";

export default {
  name: 'App',
  components: {
    SearchOverlay,
    Search,
    SearchHeader,
    StreamPlayer,
    OfferCounter,
    OfferDetailCounter,
    SocialStats,
    MoreResults,
    PollMarkup,
    TypeFilter,
    TeaserLiveTv,
    TvProgramSelect,
    TvProgramList,
    TvProgramFilter
  },
  create(){
  },
  data() {
    return {
      searchObject: new SearchObject(window.searchObj || {}),
      tvProgram: {
        labels: [],
        selected: 3,
        filter: {},
        data: false,
      }
    }
  }
}
</script>